import React from 'react';
import { connect } from 'react-redux';
import CenterPanelUpdate from './centerPanelUpdate';
import RightPanelUpdate from './rightPanelUpdate';
import CenterPanelView from './centerPanelView';
import RightPanelView from './rightPanelView';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';
export default function CreateUpdateWaitingArea(props) {
  let rightPanel = {};
  let centerPanel = {};
  let title = undefined;
  let subtitle = undefined;
  let trimmedGroup = {};
  let orgName = props.waitingArea ? props.waitingArea.organisationName : '';
  var updatingWaitingAreaName = (props.waitingArea ? props.waitingArea.name : '') + ' (' + orgName + ')';
  if (props.updateOrView == 'update') {
    rightPanel = (
      <RightPanelUpdate
        waitingArea={props.waitingArea}
        waitingAreaLocalAccessHoursForm={props.waitingAreaLocalAccessHoursForm}
      />
    );
    centerPanel = (
      <CenterPanelUpdate
        timezones={props.timezones}
        waitingAreaLocalAccessHoursForm={props.waitingAreaLocalAccessHoursForm}
        waitingArea={props.waitingArea}
      />
    );
    title = APP.LANGUAGE.WaitingAreaLocalAccessHours.TitleUpdate;
    subtitle = updatingWaitingAreaName;
  } else {
    rightPanel = (
      <RightPanelView
        waitingArea={props.waitingArea}
        waitingAreaLocalAccessHoursForm={props.waitingAreaLocalAccessHoursForm}
      />
    );
    centerPanel = (
      <CenterPanelView
        timezones={props.timezones}
        waitingAreaLocalAccessHoursForm={props.waitingAreaLocalAccessHoursForm}
        waitingArea={props.waitingArea}
      />
    );
    title = APP.LANGUAGE.WaitingAreaLocalAccessHours.TitleView;
    subtitle = updatingWaitingAreaName;
  }
  let showModal = false;
  if (props.updateOrView == 'update') {
    showModal = props.showUpdateWaitingAreaLocalAccessHoursModal;
  } else {
    showModal = props.showViewWaitingAreaLocalAccessHoursModal;
  }

  return (
    <Modal
      show={showModal}
      hideWhenClickAway={false}
      className={props.updateOrView + '-waiting-area-local-access-hours'}
    >
      <PopupHeader hideHelp={true} title={title} subtitle={subtitle} />
      <div className="content">
        <div className="main-ui-container waiting-area-update">
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <div className="ui sticky">{rightPanel}</div>
            </div>
            {centerPanel}
            <div className="bottom-rail-with-left-and-right-content mrtl">{rightPanel}</div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
